import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import ActivityQuestion, { activityQuestionStyles } from "./activityQuestion";
import { Grid } from "@material-ui/core";
import {safeParse} from "../../utils/safeParse";


export const ActivityQuestionMapper = ({ workActivityDetails, WorkActivitydetails }) => {
    const intl = useIntl();
    const classes = activityQuestionStyles();

    const details = workActivityDetails ?? WorkActivitydetails;

    const activityQuestions = useMemo(() => {
        const arr = details?.activityQuestions ?? [];
        return [...arr].sort((a, b) => (a?.displayOrder ?? 0) - (b?.displayOrder ?? 0));
    }, [details]);

    const questionAnswerJSON = useMemo(() => safeParse(details?.activityQuestionJson), [details]);
    const activityQuestionComment = useMemo(() => safeParse(details?.activityQuestionComment), [details]);

    return (
        <>
            {activityQuestions?.map((question) => (
                <Grid item xs={4} className={classes.activityQuestion} key={question.id}>
                    <ActivityQuestion
                        key={question.id}
                        question={question}
                        value={questionAnswerJSON?.[String(question.id)] ?? []}
                        language={intl.locale}
                        activityQuestionComment={activityQuestionComment}
                        xs={4}
                    />
                </Grid>
            ))}
        </>
    );
};

export default ActivityQuestionMapper;
